module.exports = __webpack_public_path__ + "img/szjc1.c06e23fc.png";